export default "__VITE_ASSET__CdC4PsjJ__"